import moment from 'moment'
import { NO_LIMIT_SITES } from '@/constants/sites'
import { PUBLIC_APP } from '@/constants/misc'

export function validInput (settings) {
  let activeSites = []
  activeSites = settings.websites.filter(site => site.active)
  // make sure that the active sites are only the ones that are not in the NO_LIMIT_SITES array
  activeSites = activeSites.filter(site => !NO_LIMIT_SITES.includes(site.name))
  if (activeSites.length === 0) {
    return true
  }
  return dateIsOldEnough(settings.startDate) &&
    dateIsOldEnough(settings.endDate)
}

export function dateIsOldEnough (date) {
  if (!PUBLIC_APP) return true
  // if we're on the public version then we only allow picking dates older than half a year
  const halfYearBack = moment().subtract(0.5, 'year').subtract(1, 'day')

  return moment(date).isBefore(halfYearBack)
}